import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'webhook-create',
    path: '/webhooks/create',
    component: () => LazyLoadView(import(/* webpackChunkName: "webhook" */ '@/views/Webhook/Mutate')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'webhook-edit',
    path: '/webhooks/:id',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "webhook" */ '@/views/Webhook/Mutate')),
    beforeEnter: isAuthenticated,
  },
]
